import { useOutletContext, Navigate } from 'react-router-dom';
import { DashboardContent } from '../components/DashboardContent';

const ALLOWED_EMAILS_DASHBOARD = [
  'contato@foradocloset.com.br',
  'ronald@ronald.com'
];

export default function DashboardPage() {
  const { user } = useOutletContext<{ user: any }>();

  if (!user || !ALLOWED_EMAILS_DASHBOARD.includes(user.email)) {
    return <Navigate to="/produtos" replace />;
  }

  return <DashboardContent />;
}
